// extracted by mini-css-extract-plugin
module.exports = {"Container":"_1pqbM","Condensed":"_3nZvJ","Warning":"_3_oMA","Text":"_3Gxwk","Metric":"_2v9K-","Verified":"_1yDnp","Percentage":"cDilt","Suffix":"_1mlw8"};